var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"buydialog"},[_c('div',{staticClass:"dialogtext"},[_c('p',[_vm._v("請與所在機構聯系獲取訪問權限")]),_vm._v(" "),_c('p',[_vm._v("或")]),_vm._v(" "),_c('p',[_c('span',{staticClass:"linktext",on:{"click":_vm.goaway}},[_vm._v("購買會員卡")])]),_vm._v(" "),_c('p',[_vm._v("暢讀全庫文獻")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c8f756b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/buyconfirm.vue
// module id = null
// module chunks = 